import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';

type InvoiceAddressCreateFormProps = {
  disabled?: boolean;
};

export const InvoiceAddressCreateForm = (props: InvoiceAddressCreateFormProps) => {
  const { disabled = false } = props;
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <ControlledTextField name='name' required disabled={disabled} label={t('member:invoiceAddress.name')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='address' required disabled={disabled} label={t('member:invoiceAddress.address')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='address2' disabled={disabled} label={t('member:invoiceAddress.address2')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='postalcode' required disabled={disabled} label={t('member:invoiceAddress.postalcode')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='city' required disabled={disabled} label={t('member:invoiceAddress.city')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='country' disabled={disabled} label={t('member:invoiceAddress.country')} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField name='email' disabled={disabled} label={t('member:invoiceAddress.email')} />
      </Grid>
    </>
  );
};
